import { Component, ApplicationRef } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ViewUpdateService } from '../../scaffold/services/view-update.service';

export interface PopUpData {
  title: string;
  message: string;
  confirmMessage: string;
  declineMessage: string;
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialog {
  data: any = {
    confirmMessage: 'Yes',
    declineMessage: 'No'
  };
  constructor(
    public dialogRef: NbDialogRef<ConfirmDialog>,
    private viewUpdate: ViewUpdateService,
    private applicationRef: ApplicationRef) {
  }

  onYesClick(): void {
    this.dialogRef.close("confirm");
    this.viewUpdate.routeUpdated("confirm")
    setTimeout(() => {
      this.applicationRef.tick();
    }, 50);
  }

  onNoClick(): void {
    this.dialogRef.close();
    setTimeout(() => {
      this.applicationRef.tick();
    }, 50);
  }

}
